<template>
    <div id="app">
        <public-header @getNavName="getVal" />
        <router-view />
        <public-footer />

        <!-- 登录 -->
        <public-dialog
            v-model="dialogShow"
            :dialogObj="dialogObj"
            @closeDialog="closeDialog"
        >
            <h2 class="tit">欢迎登录</h2>
            <public-form
                :form="loginForm"
                :list="formList"
                :btns="formBtn"
                ref="lgForm"
            />
        </public-dialog>
    </div>
</template>
<script>
import PublicHeader from "@components/header";
import PublicFooter from "@components/footer";
import PublicDialog from "@components/dialog";
import PublicForm from "@components/form";
import MyElInput from "@components/my-input";
import MyElcodeInput from "@components/my-inputcode";
import { Captcha } from '@/store/entity/captcha';

export default {
    name: "HomePage",
    components: {
        PublicHeader,
        PublicFooter,
        PublicDialog,
        PublicForm,
    },

    data() {
        return {
            dialogShow: false,
            dialogObj: {
                width: "20%",
                center: true,
            },
            loginForm: {
                mobile: "",
                code: "",
                cacode:"",
            },
            content: '发送短信验证码',
            totalTime: 60,
            canClick: true,
            image_base64: "",
        };
    },

    computed: {
        formList() {
            return [
                {
                    prop: "mobile",
                    render: "ElInput",
                    labelWidth: "auto",
                    attrs: {
                        prefixIcon: "el-icon-user",
                        placeholder: "请输入手机号",
                    },
                    position: {
                        span: 24,
                    },
                },
                {
                    prop: "cacode",
                    render: MyElcodeInput,
                    labelWidth: "auto",
                    attrs: {
                        prefixIcon: "el-icon-shopping-bag-2",
                        placeholder: "请输入验证码",
                        image_base64: this.image_base64
                    },
                    listeners: {
                        getCaptcha: this.getCaptcha,
                    },
                    position: {
                        span: 24,
                    },
                },
                {
                    prop: "code",
                    render: MyElInput,
                    labelWidth: "auto",
                    attrs: {
                        prefixIcon: "el-icon-shopping-bag-2",
                        placeholder: "请输入验证码",
                        text: this.content,
                    },
                    listeners: {
                        getCode: this.getCode,
                        
                    },
                    position: {
                        span: 24,
                    },
                },
            ];
        },
        formBtn() {
            return [
                {
                    label: "登录",
                    attrs: {
                        type: "primary",
                        style: "width: 100%",
                    },
                    listeners: {
                        click: this.handleFormSubmit,
                    },
                },
            ];
        },
    },
    created() {

        this.getCaptcha();
      
    },
    methods: {
        getVal(newVal) {
            if (newVal.text == "登录") this.dialogShow = true;
            if (newVal.text == "退出登录") this.$store.dispatch("auth/logout").then(this.$message("退出登录成功！"))
        },
        closeDialog(done) {
            this.dialogShow = false
        },
        getCode(val) {
            if (!this.loginForm.cacode) {
                this.$message("请先填写下方验证码")
                return;
                }
            //验证码
            if (!this.canClick) {
                return;
                }
            
            let data = {};
                data.phone_number = this.loginForm.mobile;
                data.timestamp = this.timestamp;
                data.captcha_hash =this.captcha_hash;
                data.captcha_results = this.loginForm.cacode;
                // console.log(data.phone_number)
                Captcha.sendSMSCode(data).then((res) => {
                    if (res) {
                        this.$message('已发送！');
                        this.canClick = false;
                        this.content = this.totalTime + 's重新发送';
                        let clock = window.setInterval(() => {
                        this.totalTime--;
                        this.content = this.totalTime + 's重新发送';
                        if (this.totalTime < 0) {
                            window.clearInterval(clock);
                            this.content = '重新发送验证码';
                            this.totalTime = 60;
                            this.canClick = true;
                        }
                        }, 1000);
                    }
                });
    
        },
        handleFormSubmit() {
            //表单信息提交
            let login = {
                        phonenumber: this.loginForm.mobile,
                        code :this.loginForm.code
                    }
            this.$store.dispatch('auth/sms_login', login).then((success) => {
                if (success) {
                    this.$message("登录成功")
                    this.closeDialog()
                    // this.$router.replace("/loginSuccess");
                }
            });
        },
        getCaptcha() {
            Captcha.getCaptcha().then((res) => {
                this.captcha_hash = res.captcha_hash;
                this.timestamp = res.timestamp;
                this.image_base64 = res.image_base64;
            });
            },
    },
};
</script>

<style lang="scss" scoped>
.el-form {
    margin-top: 30px;
}
.tit {
    color: $defaultColor;
    font-size: 24px;
    text-align: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f3f3;
}
</style>
